import { Button } from '@avanta/shared/components/ui/Button';
import { CHAT_BUTTON_INPUT_CLASSNAME } from '@avanta/shared/constants/chat';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { TextInitial } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PredefinedPhrasesModal } from './index';

export const PredefinedPhrasesTrigger = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.CHAT);
  const { showDialog } = useDialogContext();

  return (
    <Button
      variant="ghost"
      className={CHAT_BUTTON_INPUT_CLASSNAME}
      icon="only"
      type="button"
      aria-label={t('Chat.PredefinedPhrases.trigger')}
      onClick={() => showDialog({ component: <PredefinedPhrasesModal /> })}
    >
      <TextInitial className="size-4.5" />
    </Button>
  );
};
